<template>
  <div class="create-new-client-component">
    <v-loader
      v-show="isLoading"
      absolute
    />
    <v-snackbar
      v-model="showSnackbar"
      top
      color="red"
      timeout="1000"
    >
      <span>{{ errorMessage }}</span>
    </v-snackbar>
    <h1 class="font-weight-regular">
      Добавление нового клиента:
    </h1>

    <div class="button-group d-flex justify-between">
      <v-row class="justify-space-between">
        <v-col sm="5">
          <v-btn
            class="button button-back"
            width="100%"
            color="#F1F3F6"
            @click="showExitConfirmDialog = true"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
          <primary-confirm-dialog
            v-model="showExitConfirmDialog"
            confirm-text="Продолжить"
            @confirm="goToOrdersList"
          >
            <template v-slot:title>
              Вы действительно хотите закрыть заказ и перейти в список?
            </template>
          </primary-confirm-dialog>
        </v-col>
        <v-col sm="5">
          <v-btn
            class="button button-create"
            width="100%"
            color="#F1F3F6"
            :loading="isLoading"
            @click="createClient"
          >
            <font-awesome-icon icon="user-plus" />
            Создать клиента
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="user-info-section">
      <div class="user-gender d-flex justify-space-between align-end">
        <div class="gender-buttons">
          <span class="label">Пол:</span>
          <v-btn-toggle
            v-model="gender"
            dense
            group
            mandatory
            dark
            borderless
          >
            <v-btn
              v-ripple="false"
              value="FEMALE"
              class="button font-weight-medium"
              light
            >
              Женский
            </v-btn>
            <v-btn
              v-ripple="false"
              value="MALE"
              class="button font-weight-medium"
              light
            >
              Мужской
            </v-btn>
          </v-btn-toggle>
        </div>
        <v-btn
          class="button"
          color="#F1F3F6"
          @click="tryCreateAnonymousClient"
        >
          Без регистрации
        </v-btn>

        <primary-confirm-dialog
          v-model="showConfirmDialog"
          confirm-text="Продолжить"
          :loading="isLoading"
          close-after-loading
          @confirm="createAnonymousClient"
        >
          <template v-slot:title>
            Продолжить оформление заказа без регистрации клиента?
          </template>
          <template #subtitle>
            <div class="font-weight-medium text--accent-3 text-center">
              Заказ будет создан без имени и телефона клиента
            </div>
          </template>
        </primary-confirm-dialog>
      </div>

      <validation-observer ref="validation">
        <div class="user-phone">
          <v-row>
            <v-col>
              <span class="label">Телефон:</span>
              <validation-provider
                v-slot="{ errors }"
                name="phone"
                rules="required|min:10"
                mode="passive"
              >
                <v-text-field
                  v-model="phone"
                  v-mask="'+7 (###) ###-##-##'"
                  placeholder="+7 (___) ___-__-__"
                  hide-details="auto"
                  class="text-field"
                  flat
                  solo
                  :error="!!errors.length"
                  @focus="showPhoneKeyboard = true"
                  @blur="searchActiveClient"
                />
              </validation-provider>
            </v-col>
            <v-col>
              <span class="label">Имя:</span>
              <validation-provider
                v-slot="{ errors }"
                name="name"
                rules="required|min:2"
                mode="passive"
              >
                <v-text-field
                  v-model="name"
                  hide-details="auto"
                  class="text-field"
                  flat
                  solo
                  :error="!!errors.length"
                  @focus="showPhoneKeyboard = false"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <v-row class="user-names flex-wrap">
            <v-col
              v-if="name.length < 2 && !suggests.length && !isSuggestsLoading"
              sm="12"
              class="d-flex align-center justify-center"
            >
              <span class="d-block display-3 text-center">
                Начните вводить имя
              </span>
            </v-col>
            <v-col
              v-if="name.length > 2 && !suggests.length && !isSuggestsLoading"
              sm="12"
              class="d-flex align-center justify-center"
            >
              <span class="d-block display-3 text-center">
                Нет подходящих имен
              </span>
            </v-col>
            <v-col
              v-for="(suggest, i) in suggests"
              :key="i"
              sm="3"
            >
              <v-btn
                class="button text-normalize"
                width="100%"
                depressed
                @click="setName(suggest)"
              >
                {{ suggest }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </validation-observer>
      <!--      <v-keyboard v-show="showPhoneKeyboard" v-model="phone" id="phone" />-->
      <!--      <v-keyboard v-show="!showPhoneKeyboard" v-model="name" id="name" />-->
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import ConfirmDialog from '@/components/ui/dialogs/ConfirmDialog.vue'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'

  export default {
    name: 'CreateClient',
    components: {
      PrimaryConfirmDialog,
      ConfirmDialog,
      VLoader,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        showSnackbar: false,
        isLoading: false,
        isSuggestsLoading: false,
        showConfirmDialog: false,
        showExitConfirmDialog: false,
        name: '',
        phone: '',
        errorMessage: '',
        gender: 'FEMALE',
        suggests: [],
        showPhoneKeyboard: true,
        getSuggestTimeout: null,
        searchClientTimeout: null,
      }
    },
    computed: {
      ...mapState({
        newClientPhone: state => state.newOrder.newClientPhone,
        newOrderIncomingPhone: state => state.newOrder.newOrderIncomingPhone,
        activeClientId: state => state.newOrder.activeClientId,
        callId: state => state.newOrder.callId,
      }),
      ...mapGetters({
        isCallCenterUser: 'auth/isCallCenterUser',
      }),
    },
    watch: {
      name () {
        this.getSuggestNames()
      },
      gender () {
        if (this.name) {
          this.getSuggestNames()
        }
      },
    },
    mounted () {
      if (this.newClientPhone) {
        this.$nextTick(() => {
          this.phone = this.newClientPhone.slice(1)
        })
      }
      if (this.activeClientId) {
        this.createBasket(this.activeClientId)
      }
    },
    beforeDestroy () {
      this.$store.commit('newOrder/setNewOrderIncomingPhone', null)
    },
    methods: {
      goToOrdersList () {
        this.$store.commit('app/setAllowPageExitWithoutConfirm', true)
        this.$router.push('/orders')
      },
      getSuggestNames () {
        if (this.name.length > 1) {
          this.isSuggestsLoading = true
          clearTimeout(this.getSuggestTimeout)
          this.getSuggestTimeout = setTimeout(() => {
            const payload = {
              name: this.name,
              gender: this.gender,
              count: 8,
            }
            this.$store
              .dispatch('suggests/fetchNamesSuggestList', payload)
              .then((res) => {
                if (res.status === 200) {
                  this.suggests = res.data.suggests
                } else {
                  this.suggests = []
                }
              }).finally(() => {
                this.isSuggestsLoading = false
              })
          }, 500)
        }
      },
      tryCreateAnonymousClient () {
        if (this.isCallCenterUser) {
          this.showConfirmDialog = true
        } else {
          this.createAnonymousClient()
        }
      },
      createAnonymousClient () {
        this.isLoading = true

        this.$store
          .dispatch('clients/createClients', {
            status: true,
          })
          .then((res) => {
            if (res.status === 200) {
              this.createBasket(res.data.id)
            } else {
              console.warn('Error', res)
              this.showSnackbar = true
              this.errorMessage = res.response.data.message
            }
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.isLoading = false
          })
      },
      searchActiveClient () {
        if (this.phone.length === 18) {
          this.isLoading = true
          const meta = {
            phone: this.phone.replace(/[- )(/+]/g, ''),
          }
          this.$store.dispatch('clients/fetchClientsList', meta)
            .then(res => {
              if (res.status === 200) {
                if (res.data.items.length) {
                  this.showSuccessMessage('Клиент найден в базе')
                  const clientId = res.data.items[0].id
                  this.createBasket(clientId)
                }
              }
            })
            .catch((err) => this.showErrorFromResponse(err))
            .finally(() => {
              this.isLoading = false
            })
        }
      },
      async createClient () {
        const isValid = await this.$refs.validation.validate()
        if (!isValid) return
        this.isLoading = true
        const payload = {
          phone: this.phone.match(/[0-9]/g).join(''),
          name: this.name,
          incomingPhone: this.newOrderIncomingPhone,
        }
        this.$store
          .dispatch('clients/createClients', payload)
          .then((res) => {
            if (res.status === 200) {
              this.createBasket(res.data.id)
            } else {
              console.warn('Error', res)
              this.showSnackbar = true
              this.errorMessage = res.response.data.message
            }
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.isLoading = false
          })
      },
      createBasket (id) {
        const payload = {
          clientId: id,
          phoneCallId: this.callId,
        }
        if (this.newOrderIncomingPhone) {
          payload.callPhone = this.newOrderIncomingPhone
        }
        this.$store
          .dispatch('baskets/createBasket', payload)
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit('newOrder/setCallId', null)
              // Если корзина создалась - находим ее и добавляем в стор
              history.pushState({}, null, this.$route.path + `?id=${res.data.id}`)
              this.$store
                .dispatch('baskets/fetchSingleBasket', res.data.id)
                .then((res) => {
                  if (res.status === 200) {
                    this.$store.commit('baskets/setBasket', res.data.data)
                    this.$store.commit('newOrder/setStep', 1)
                  }
                })
            } else {
              console.warn('Error', res)
              this.showSnackbar = true
              this.errorMessage = res.response.data.message
            }
          })
          .catch((err) => this.showErrorFromResponse(err))
      },
      setName (name) {
        this.name = name
      },
      goStepOne () {
        this.$store.commit('newOrder/setStep', 1)
      },
    },
  }
</script>

<style lang="less" scoped>
.create-new-client-component {
  position: relative;
  z-index: 0;
  padding-top: 84px;

  // компактный десктоп: блок прижат к верху, высота экрана на счету
  .media-compact-pc({
    padding-top: 12px;
  });

  h1 {
    font-size: 34px;
    line-height: 1;
    margin-bottom: 33px;
  }

  .label {
    display: block;
    margin-bottom: 14px;
    font-size: 20px;
    line-height: 21px;
  }

  .button {
    height: 80px;
    border-radius: 10px;

    svg {
      margin-right: 8px;
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    &.error--text {
      ::v-deep {
        .v-input__slot {
          border: 2px solid @color-error;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .button-group {
    margin-bottom: 30px;

    .button {
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;
    }

    .button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-create {
      color: #ffffff;
      background-color: @color-success !important;

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .user-info-section {
    .button {
      border-radius: 10px !important;
    }

    .user-gender {
      margin-bottom: 22px;

      .gender-buttons {
        flex: 1;

        .button {
          margin-right: 15px;

          &.v-item--active {
            color: #ffffff;
            background-color: @color-primary !important;
            &:before {
              display: none;
            }
          }
        }
      }

      .button {
        max-width: 180px;
        width: 100%;
        font-size: 15px;
        box-shadow: 0 3px 6px #00000029 !important;
      }
    }
  }

  .user-names {
    min-height: 208px;

    .button {
      font-size: 24px;
      line-height: 18px;
    }
  }
}
</style>
